<template>
  <div style="position: relative;">
    <el-form ref="specialistFilter" :model="specialist" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="名称" prop="formFilter.specialistName">
          <el-input class="filter-item" v-model="specialist.formFilter.specialistName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.specialistType">
          <el-select class="filter-item" v-model="specialist.formFilter.specialistType" :clearable="true" filterable
            placeholder="" :loading="specialist.specialistType.impl.loading"
            @visible-change="specialist.specialistType.impl.onVisibleChange"
            @change="onSpecialistTypeValueChange">
            <el-option v-for="item in specialist.specialistType.impl.dropdownList" :key="item.id"
              :value="item.id" :label="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="批次" prop="formFilter.batchList">
          <el-select v-model="specialist.formFilter.batchList" clearable  multiple placeholder="请选择">
            <el-option key="十二" label="十二" value="十二"></el-option>
            <el-option key="十三" label="十三" value="十三"></el-option>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="备案状态" prop="formFilter.filingPassed">-->
<!--          <el-select class="filter-item" v-model="specialist.formFilter.filingPassed" :clearable="true" filterable-->
<!--                     placeholder="" :loading="specialist.filingPassed.impl.loading"-->
<!--                     @visible-change="specialist.filingPassed.impl.onVisibleChange"-->
<!--                     @change="onFilingPassedValueChange">-->
<!--            <el-option v-for="item in specialist.filingPassed.impl.dropdownList" :key="item.id"-->
<!--                       :value="item.id" :label="item.name"-->
<!--            />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="是否委派" prop="formFilter.appointFlag">-->
<!--          <el-select class="filter-item" v-model="specialist.formFilter.appointFlag" :clearable="true" filterable-->
<!--            placeholder="" :loading="specialist.appointFlag.impl.loading"-->
<!--            @visible-change="specialist.appointFlag.impl.onVisibleChange"-->
<!--            @change="onAppointFlagValueChange">-->
<!--            <el-option v-for="item in specialist.appointFlag.impl.dropdownList" :key="item.id"-->
<!--              :value="item.id" :label="item.name"-->
<!--            />-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetSpecialist">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshSpecialist(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('specialist:specialist:export')"
                   @click="onExportClick()">
          导出
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialist" :data="specialist.Specialist.impl.dataList" :size="defaultFormItemSize" @sort-change="specialist.Specialist.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="specialist.Specialist.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="specialist.Specialist.impl.getTableIndex" />
          <el-table-column label="名称" prop="specialistName">
          </el-table-column>
          <el-table-column label="类型" prop="specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="联系电话" prop="mobilePhone">
          </el-table-column>
          <el-table-column label="照片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                :preview-src-list="getPictureList(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
<!--          <el-table-column label="备案状态" prop="filingPassedDictMap.name">-->
<!--          </el-table-column>-->
          <el-table-column label="认证时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column label="服务期" prop="signYear">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.signYear, 'day')}}</span>
            </template>
          </el-table-column>-->
          <el-table-column label="是否热门专家" prop="hotFlag">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.hotFlagDictMap ? scope.row.hotFlagDictMap.name : 0" placement="top">
                  <el-switch
                    @change="switchHotChange($event, scope.row)"
                    v-model="scope.row.hotFlag"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                    active-text="是"
                    inactive-text="否">
                  </el-switch>
                </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="是否明星专家" prop="starFlag">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.starFlagDictMap ? scope.row.starFlagDictMap.name : 0" placement="top" >
                <el-switch
                  @change="switchStarChange($event, scope.row)"
                  v-model="scope.row.starFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onSpecialistPageClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('specialist:specialist:specialistPage')">
                详情
              </el-button>
<!--              <el-button @click.stop="onSignContractWinClick(scope.row)" type="text" :size="defaultFormItemSize"-->
<!--                :disabled="!checkPermCodeExist('specialist:specialist:signContractWin')">-->
<!--                签约-->
<!--              </el-button>-->
<!--              <el-button @click.stop="onSpecialistPageEditClick(scope.row)" type="text" :size="defaultFormItemSize"-->
<!--                :disabled="!checkPermCodeExist('specialist:specialist:specialistPageEdit')">-->
<!--                编辑-->
<!--              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialist.Specialist.impl.totalCount"
            :current-page="specialist.Specialist.impl.currentPage"
            :page-size="specialist.Specialist.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialist.Specialist.impl.onCurrentPageChange"
            @size-change="specialist.Specialist.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistController, DictionaryController } from '@/api';
import signContractWin from '@/views/specialist/signContractWin.vue';

export default {
  name: 'specialist',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      hotFlag: true,
      value: '1',
      fit: 'scale-down',
      specialist: {
        formFilter: {
          specialistName: undefined,
          specialistType: undefined,
          appointFlag: undefined,
          filingPassed: undefined,
          batchList: undefined
        },
        formFilterCopy: {
          specialistName: undefined,
          specialistType: undefined,
          appointFlag: undefined
        },
        Specialist: {
          impl: new TableWidget(this.loadSpecialistWidgetData, this.loadSpecialistVerify, true, true, 'createTime', 1)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        appointFlag: {
          impl: new DropdownWidget(this.loadAppointFlagDropdownList)
        },
        filingPassed: {
          impl: new DropdownWidget(this.loadFilingPassedDropdownList)
        },
        isInit: false
      }
    }
  },
  methods: {
    switchHotChange (event, row) {
      console.log('$event, scope.row', event, row)
      row.hotFlag = event
      let params = {
        specialistDto: {
          ...row
        }
      };
      SpecialistController.update(this, params).then(res => {
        this.specialist.Specialist.impl.refreshTable();
      }).catch(e => {});
    },
    switchStarChange (event, row) {
      console.log('$event, scope.row', event, row)
      row.starFlag = event
      let params = {
        specialistDto: {
          ...row
        }
      };
      SpecialistController.update(this, params).then(res => {
        this.specialist.Specialist.impl.refreshTable();
      }).catch(e => {});
    },
    onResetSpecialist () {
      this.$refs.specialistFilter.resetFields();
      this.refreshSpecialist(true);
    },
    /**
     * 专家主表数据获取函数，返回Promise
     */
    loadSpecialistWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        specialistDtoFilter: {
          auditStatus: this.AuditStatusDict.SHTG,
          specialistName: this.specialist.formFilter.specialistName,
          specialistType: this.specialist.formFilter.specialistType,
          filingPassed: this.specialist.formFilter.filingPassed,
          batchList: this.specialist.formFilter.batchList
        },
        orderParam: [{
          fieldName: 'createTime',
          asc: false
        }]
      }
      // console.log(params)
      return new Promise((resolve, reject) => {
        SpecialistController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.specialist.Specialist.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.specialist.Specialist.impl.currentRow.id, 'id');
              this.$refs.specialist.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家主表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistVerify () {
      return true;
    },
    /**
     * 类型下拉数据获取函数
     */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onSpecialistTypeValueChange (value) {
    },
    /**
     * 是否委派下拉数据获取函数
     */
    loadAppointFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否委派选中值改变
     */
    onAppointFlagValueChange (value) {
    },
    /**
     * 备案状态下拉数据获取函数
     */
    loadFilingPassedDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictFilingPassedDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 备案状态选中值改变
     */
    onFilingPassedValueChange (value) {
    },
    /**
     * 更新专家管理
     */
    refreshSpecialist (reloadData = false) {
      if (reloadData) {
        this.specialist.Specialist.impl.refreshTable(true, 1);
      } else {
        this.specialist.Specialist.impl.refreshTable();
      }
      if (!this.specialist.isInit) {
        // 初始化下拉数据
      }
      this.specialist.isInit = true;
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        specialistDtoFilter: {
          auditStatus: this.AuditStatusDict.SHTG,
          specialistName: this.specialist.formFilter.specialistName,
          specialistType: this.specialist.formFilter.specialistType,
          filingPassed: this.specialist.formFilter.filingPassed,
          batchList: this.specialist.formFilter.batchList
        }
      };

      SpecialistController.export(this, params, '专家列表.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    /**
     * 详情
     */
    onSpecialistPageClick (row) {
      let params = {
        id: row.id,
        viewFlag: 1
      };

      params.closeVisible = 1;
      this.$router.push({name: 'specialistPage', query: params});
    },
    /**
     * 签约
     */
    onSignContractWinClick (row) {
      let params = {
        specialistId: row.id
      };

      this.$dialog.show('签约', signContractWin, {
        area: '800px'
      }, params).then(res => {
        this.specialist.Specialist.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onSpecialistPageEditClick (row) {
      let params = {
        id: row.id,
        viewFlag: 0
      };

      params.closeVisible = 1;
      this.$router.push({name: 'specialistPage', query: params});
    },
    onResume () {
      this.refreshSpecialist();
    },
    initFormData () {
    },
    formInit () {
      this.refreshSpecialist();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // this.specialist.formFilter.filingPassed = '1'
    this.specialist.filingPassed.impl.onVisibleChange(true).catch(e => {});
  },
  watch: {
  }
}
</script>
